import "./reserva.css";

import FormSantaClara from "./form2/formSantaClara";
import FormEspectaculos from "./form3/formEspectaculos";
import Form4 from "./form4/form4";

function Reserva({ ticket, evento }) {
  console.log(evento);
  if (evento.name === "Club de lectura adultos 1" || evento.name === "Club de lectura adultos 2") {
    return <FormEspectaculos ticket={ticket} evento={evento} />;
  }
  if (evento._id === "624487bd04de14b13a9da6ed" || evento._id === "627cd7866f9618c20ea6647e") {
    return <Form4 ticket={ticket} evento={evento} />;
  }
  if (evento._id === "626ba5cc0902a1b110d33c7c" || evento._id === "626bac570902a1b110d34f8b") {
    return <Form4 ticket={ticket} evento={evento} />;
  }
  if (evento._id === "627d5a746f9618c20ea6f947") {
    return <Form4 ticket={ticket} evento={evento} />;
  }
 
  
  if (evento.tags[1] !== "") {
    if (evento.tags[1] === "+ 18 años"|| evento.tags[1] === "+18 años"|| evento.tags[1] === "Adultos" ) {
      return <FormEspectaculos ticket={ticket} evento={evento} />;
    }
  }
  if (evento.tags[0] !== "") {
    if (evento.tags[0] === "Biblioteca Municipal") {
      return <FormSantaClara ticket={ticket} evento={evento} />;
    } else if (evento.tags[0] === "Centro Cultural Santa Clara") {
      return <FormSantaClara ticket={ticket} evento={evento} />;
    } else if (evento.tags[0] === "Espectáculos") {
      return <FormEspectaculos ticket={ticket} evento={evento} />;
    } else if (evento.tags[0] === "Museo de la Industria Rialia") {
      return <FormSantaClara ticket={ticket} evento={evento} />;
    }
  }
}

export default Reserva;
